import React, { useEffect, useRef, useState } from 'react';
import { Contest, DesignDetails, DSLTag } from '../../../global';
import { FormProvider, Controller, SubmitHandler, useForm } from 'react-hook-form';
import { useAuth } from '../../../context/AuthContext';
import { Form, useNavigate } from 'react-router-dom';
import axios from 'axios';
import axiosHelper from '../../../helpers/axiosHelper';
import { ROUTEPATHS } from '../../../routes/routePaths';
import styles from './UploadComponent.module.scss';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileVideo, faFileZipper } from '@fortawesome/free-regular-svg-icons';
import { faCircleQuestion, faXmark, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import Dropzone from 'react-dropzone';
import PopUpSaveDraft from '../../PopUp/PopUpSaveDraft/PopUpSaveDraft';
import KeywordsEditor from './KeywordsEditor';
import FormField from '../../Forms/FormField';
import { TextInputField } from '../../Forms/TextInputField';
import { error } from 'console';

interface Props {
  contest: Contest;
  design?: DesignDetails;
  setPopupMessage: (value: boolean) => void;
  mutateCallback?: (value: DesignDetails) => void;
}

const UploadComponent: React.FC<Props> = ({ design, contest, setPopupMessage, mutateCallback }) => {
  const imageMimesToAccept = { 'image/png': ['.png'], 'image/jpg': ['.jpg'], 'image/jpeg': ['.jpeg'] };
  const [defaultFormValues, setDefaultFormValues] = useState(design || { isHidden: false });
  const { loggedUser } = useAuth();
  const [suggestionArray, setSuggestionArray] = useState<DSLTag[]>([]);
  const [isEditing, setIsEditing] = useState(false);
  const methods = useForm<Partial<DesignDetails>>({
    defaultValues: defaultFormValues,
  });
  const redirect = useNavigate();
  const [tagsArray, setTagsArray] = useState<string[]>([]);
  const [tagString, setTagString] = useState('Desall ');
  const [images, setImages] = useState<File[]>([]);
  const [coverImage, setCoverImage] = useState<File>();
  const [coverError, setCoverError] = useState(false);
  const [tagsError, setTagsError] = useState(false);
  const [archiveFile, setArchiveFile] = useState<File>();
  const [videoFile, setVideoFile] = useState<File>();
  const [progress, setProgress] = useState(0);
  const [popUpArchive, setPopUpArchive] = useState(false);
  const [popUpVideo, setPopUpVideo] = useState(false);
  const [saveDraftPopupVisible, setSaveDraftPopupVisible] = useState(false);
  const draft = useRef(false);
  const [visChangeDisabled, setVisChangeDisabled] = useState(false);

  const isNaming = contest.contestType === 'Naming';

  useEffect(() => {
    if (contest) {
      const now = new Date(contest.startDate).getTime();
      const startDateNumber = new Date(contest.startDate).getTime();
      const endDateNumber = new Date(contest.endUploadDate).getTime();
      const halfDate = (endDateNumber - startDateNumber) / 2;
      if (now - startDateNumber < halfDate && !contest.isPrivate) {
        setVisChangeDisabled(false);
      } else {
        setVisChangeDisabled(true);
      }
    }
  }, [contest]);

  useEffect(() => {
    if (design) {
      console.log(design);
      setIsEditing(true);
    } else {
      setIsEditing(false);
    }
  }, [design]);

  const handleVideoSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(event?.target?.files?.[0]);
    if (event?.target?.files) {
      let sizeMb = event.target.files?.[0].size / 1024 / 1024;
      if (sizeMb < 50) {
        setVideoFile(event.target.files?.[0]);
      } else {
        // alert('Upload file up to 50MB');
      }
    }
  };

  const handleArchiveSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(event?.target?.files?.[0]);
    if (event?.target?.files) {
      let sizeMb = event.target.files?.[0].size / 1024 / 1024;
      if (sizeMb < 100) {
        setArchiveFile(event.target.files?.[0]);
      } else {
        // alert('Upload file up to 100MB');
      }
    }
  };

  const onCoverDrop = (e: any) => {
    console.log(e);
    if (isEditing) {
      removeImage(1);
    }
    setCoverImage(e?.[0]);
    setCoverError(false);
  };

  const onImageDrop = (e: any) => {
    const chosenFiles = Array.prototype.slice.call(e);
    handleImageFiles(chosenFiles);
  };
  const removeImage = async (index: number) => {
    if (design) {
      console.log('REMOVE IMAGE ', index);
      if (index === 1) {
        const updateResult = await axiosHelper.deleteFromDesignWLF('image1Attachment', design.id);
        if (updateResult) {
          if (mutateCallback) {
            mutateCallback(updateResult);
          }
        }
      }
    }
  };
  const handleImageFiles = (files: File[]) => {
    const uploaded: File[] = [...images];
    let othersCount = 0;
    if (isEditing && design) {
      Array.from({ length: 4 }, (_, index) => {
        const key = `image${index + 2}Attachment` as keyof DesignDetails;
        const attachment = design[key];
        if (attachment) {
          othersCount++;
        }
      });
    }
    if (uploaded.length + othersCount + files.length > 4) {
      return;
    }
    files.map((file: File) => {
      if (uploaded.findIndex((f: File) => f.name === file.name) === -1) {
        uploaded.push(file);
      }
    });
    setImages(uploaded);
  };

  const deleteImg = (index: number) => {
    const uploaded: File[] = [...images];
    uploaded.splice(index, 1);
    setImages(uploaded);
  };

  const tagstring = (e: string) => {
    setTagString(e);
  };

  const addTag = (tag: string) => {
    // console.log(tag);
    let string = tagString;
    let index = string.split(' ').length - 1;
    // console.log(string.split(' ')[index]);
    let stringWithSuggestion = string.replace(new RegExp(string.split(' ')[index] + '$'), tag + ' ');
    setTagString(stringWithSuggestion);
  };

  const tagStringCheck = () => {
    let string = tagString;
    let index = string.split(' ').length - 1;
    // console.log(string.split(' ')[index]);
    if (string.split(' ')[index] !== '') {
      return true;
    } else {
      return false;
    }
  };

  const presignAndUpload = async (file: File, index: number) => {
    const response = await axiosHelper.getPresignedUrl(index, file.name, file.size, file.type);
    if (response) {
      const uploadResponse = await axios.put(response.data.payload, file);
      if (uploadResponse) {
        return response.data.id;
      }
    }
    return null;
  };

  const validateData = () => {
    // Add validation logic here if needed
  };

  const onSubmit: SubmitHandler<Partial<DesignDetails>> = async (data) => {
    console.log('ON SUBMIT');
    console.log(data);
    // react-hook-form only invokes this callback after registered fields pass
    // validation. Keep this flag for the file/tag checks below, which are not
    // registered form fields.
    let hasErrors = false;
    if (!draft.current) {
      console.log('NOT DRAFT');
      if (tagString.length < 1) {
        setTagsError(true);
        hasErrors = true;
      }
      setCoverError(false);
      if (!coverImage) {
        if (!isEditing) {
          setCoverError(true);
          hasErrors = true;
        } else if (!design?.image1Attachment) {
          setCoverError(true);
          hasErrors = true;
        }
      }
    }
    if (hasErrors) {
      setProgress(0);
      return;
    }
    // if (progress === 0) {
    //   console.log('PROGRESS IS ZERO RETURNING')
    //   return;
    // }
    let attachments: string[] = [];
    let totalSizeOfFiles = 0;
    let coverPercentage = 0;
    let imagesPercentage = 0;
    let archivePercentage = 0;
    let videoPercentage = 0;
    const totalPercentage = 80;
    if (coverImage) {
      totalSizeOfFiles += coverImage.size;
    }
    if (images) {
      totalSizeOfFiles += images.reduce((acc, file) => acc + file.size, 0);
    }
    if (archiveFile) {
      totalSizeOfFiles += archiveFile.size;
    }
    if (videoFile) {
      totalSizeOfFiles += videoFile.size;
    }

    if (totalSizeOfFiles > 0) {
      if (coverImage) {
        coverPercentage = (coverImage.size / totalSizeOfFiles) * totalPercentage;
      }
      if (images) {
        imagesPercentage = (images.reduce((acc, file) => acc + file.size, 0) / totalSizeOfFiles) * totalPercentage;
      }
      if (archiveFile) {
        archivePercentage = (archiveFile.size / totalSizeOfFiles) * totalPercentage;
      }
      if (videoFile) {
        videoPercentage = (videoFile.size / totalSizeOfFiles) * totalPercentage;
      }
    }

    setProgress(5);

    if (coverImage) {
      setProgress(coverPercentage);
      const uuid = await presignAndUpload(coverImage, 0);
      if (uuid) {
        attachments.push(uuid);
      }
    }
    console.log(attachments);
    if (images) {
      for (let index = 0; index < images.length; index++) {
        const image = images[index];
        setProgress(coverPercentage + imagesPercentage * ((index + 1) / images.length));
        const uuid = await presignAndUpload(image, index + 1);
        if (uuid) {
          attachments.push(uuid);
        }
      }
    }
    console.log(attachments);
    if (archiveFile) {
      setProgress(coverPercentage + imagesPercentage + archivePercentage);
      const uuid = await presignAndUpload(archiveFile, 5);
      if (uuid) {
        attachments.push(uuid);
      }
    }
    console.log(archiveFile);
    if (videoFile) {
      setProgress(coverPercentage + imagesPercentage + archivePercentage + videoPercentage);
      const uuid = await presignAndUpload(videoFile, 6);
      if (uuid) {
        attachments.push(uuid);
      }
    }
    setProgress(80);
    console.log(attachments);
    const uuids = attachments.join(',');

    data.isTemporary = draft.current;

    console.log(data);
    console.log(isEditing);
    data.tempUploads = uuids;
    if (design) {
      const createResponse = await axiosHelper.updateDesignWLF(data, design.id);
      if (createResponse) {
        setProgress(100);
        // console.log('MUTATE ' + 'uid|' + loggedUser!.id);
        // const portfolio = await axiosHelper.fetchPortfolio('uid|' + loggedUser!.id);
        // console.log('GOT PORTFOLIO');
        // console.log(portfolio);
        // mutate('uid|' + loggedUser!.id, null);
        redirect(`/${ROUTEPATHS.COMMUNITY}/${loggedUser!.nameForURL}/${ROUTEPATHS.COMMUNITY_PORTFOLIO}`);
      }
    } else {
      const createResponse = await axiosHelper.createDesignWLF(data, contest?.id);
      if (createResponse) {
        setProgress(100);
        setTimeout(() => {
          // mutate('uid|' + loggedUser!.id, null, { revalidate: true });
          redirect(`/${ROUTEPATHS.COMMUNITY}/${loggedUser!.nameForURL}/${ROUTEPATHS.COMMUNITY_PORTFOLIO}`);
        }, 400);
      }
    }
  };
  const showSaveDraftPopUp = async () => {
    console.log('ShowSaveDraft PopUp');
    setProgress(0);
    draft.current = true;
    const isValid = await methods.trigger();

    if (isValid) {
      setSaveDraftPopupVisible(true);
    }
  };

  const publish = () => {
    draft.current = false;
    methods.handleSubmit(onSubmit)();
  };

  return (
    <>
      <div className="row ">
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <div className="col-12 px-3 ">
              <div className="row ">
                <div className="col-12 col-md-2 mb-3"></div>
                <div className="col-12 col-md-10 text mb-5">
                  <i>
                    To upload your design, you have to fill the mandatory fields (<span className="color-dark_red">*</span>)
                  </i>
                </div>
              </div>
              <TextInputField name="name" label="Project name" required placeholder="Identify your project with a name" maxLength={50} />
              {isNaming && (
                <TextInputField name="payoff" label="Payoff" required placeholder="Write a short payoff for your project" maxLength={250} multiline tooltipKey="designPayoff" />
              )}
              {!isNaming && (
                <>
                  <FormField name="isHidden" label="Design privacy" tooltipKey="designPrivacy">
                    <>
                      <input
                        type="radio"
                        className="  align-middle me-4 "
                        value="false"
                        {...methods.register('isHidden')}
                        disabled={visChangeDisabled}
                        defaultChecked={defaultFormValues.isHidden === false}
                      />
                      <span className={` me-5 text ${visChangeDisabled ? 'color-dark_grey_50' : ''}`}>Visible</span>
                      &nbsp;
                      <input
                        type="radio"
                        className=" align-middle me-4 "
                        value="true"
                        {...methods.register('isHidden')}
                        disabled={visChangeDisabled}
                        defaultChecked={defaultFormValues.isHidden === true}
                      />
                      <span className={` me-5 text ${visChangeDisabled ? 'color-dark_grey_50' : ''}`}>Hidden</span>
                    </>
                  </FormField>
                  <TextInputField
                    name="textAbstract"
                    label="Abstract"
                    required
                    placeholder="Explain in some words your project"
                    maxLength={250}
                    multiline
                    tooltipKey="designAbstract"
                  />
                </>
              )}
              <TextInputField name="textDescription" label="Description" placeholder="Description goes here" multiline tooltipKey="designDescription" />

              {!isNaming && (
                <>
                  <FormField
                    name="coverImage"
                    label="Cover Image"
                    required
                    error={coverError ? { message: 'Cover image is required' } : undefined}
                    inputColumnClassName={`${styles.uploadCoverContainer}`}
                    tooltipKey="designCoverImage"
                  >
                    <Dropzone onDrop={onCoverDrop} accept={imageMimesToAccept} maxSize={31457280}>
                      {({ getRootProps, getInputProps }) => (
                        <section className={`${styles.dropzone} bg-light d-flex align-items-center  justify-content-center`}>
                          <div className="col-12 d-flex h-100 flex-column align-items-center justify-content-center text-center" {...getRootProps()}>
                            <input {...getInputProps()} />
                            <span style={{ cursor: 'default' }}>
                              Drag and drop an image or <span style={{ color: '#7997c5', cursor: 'pointer' }}>choose a file</span> from your computer <br />
                              (allowed formats: .jpg, .png)
                            </span>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                  </FormField>

                  <div className={`row  mb-7 ${coverImage ? '' : 'd-none'}`}>
                    <div className="col-12 col-md-2 text fw-bold mb-3">
                      <div className=" d-flex justify-content-between "></div>
                    </div>
                    <div className={`col-12 col-md-10  d-flex flex-column align-items-center justify-content-center `}>
                      {coverImage && (
                        <div className=" d-flex" style={{ width: '100%' }}>
                          <div className={`${styles.previewImg}`}>
                            <img src={URL.createObjectURL(coverImage)} className={`${styles.previewImg}`} alt="Uploaded cover" />
                          </div>
                          <div className="d-flex flex-row w-100 align-items-center justify-content-center ">
                            <span className="text-xl">{coverImage.name}</span>
                          </div>
                          <div className=" d-flex align-items-center justify-content-end ">
                            <div className={` ${styles.removeButton}`} onClick={() => setCoverImage(undefined)}>
                              <FontAwesomeIcon icon={faXmark as IconProp} className=" text-16 me-0" />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className={`row  mb-7 ${design?.image1Attachment ? '' : 'd-none'}`}>
                    <div className="col-12 col-md-2 text fw-bold mb-3">
                      <div className=" d-flex justify-content-between "></div>
                    </div>
                    <div className={`col-12 col-md-10  d-flex flex-column align-items-center justify-content-center `}>
                      {design?.image1Attachment && (
                        <div className=" d-flex" style={{ width: '100%' }}>
                          <div className={`${styles.previewImg}`}>
                            <img src={design?.image1Attachment.s3Path} className={`${styles.previewImg}`} alt="Uploaded cover" />
                          </div>
                          <div className="d-flex flex-row w-100 align-items-center justify-content-center ">
                            <span className="text-xl">{design?.image1Attachment.originalFileName}</span>
                          </div>
                          <div className=" d-flex align-items-center justify-content-end ">
                            <div className={` ${styles.removeButton}`} onClick={() => removeImage(1)}>
                              <FontAwesomeIcon icon={faXmark as IconProp} className=" text-16 me-0" />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <FormField name="imageFiles" label="Image Files" inputColumnClassName={`${styles.uploadCoverContainer}`}>
                    <Dropzone onDrop={onImageDrop} accept={imageMimesToAccept} maxSize={31457280}>
                      {({ getRootProps, getInputProps }) => (
                        <section className={`${styles.dropzone} bg-light d-flex align-items-center  justify-content-center`}>
                          <div className="col-12 d-flex h-100 flex-column align-items-center justify-content-center text-center" {...getRootProps()}>
                            <input {...getInputProps()} />
                            <span style={{ cursor: 'default' }}>
                              Drag and drop an image or <span style={{ color: '#7997c5', cursor: 'pointer' }}>choose a file</span> from your computer <br />
                              (allowed formats: .jpg, .png). Max 4 images.
                            </span>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                  </FormField>

                  <div className={`row mb-5 ${images.length > 0 ? '' : 'd-none'} `}>
                    <div className="col-12 col-md-2 text fw-bold mb-3">
                      <div className=" d-flex justify-content-between "></div>
                    </div>
                    <div className={`col-12 col-md-10 mb-5 d-flex flex-column align-items-center justify-content-center  `}>
                      {images?.map((item, index) => (
                        <div key={index} className="mt-2 d-flex" style={{ width: '100%' }}>
                          <div className={`${styles.previewImg}`}>
                            <img src={URL.createObjectURL(item)} key={index} className={`${styles.previewImg}`} alt="uploaded" style={{ height: '100%' }} />
                          </div>
                          <div className="d-flex flex-row w-100 align-items-center justify-content-center ">
                            <span className="text-xl">{item.name}</span>
                          </div>
                          <div className=" d-flex align-items-center justify-content-end ">
                            <div
                              className={`${styles.removeButton}`}
                              // style={{ borderRadius: '8px', height: '50px', width: '50px' }}
                              onClick={() => deleteImg(index)}
                            >
                              <FontAwesomeIcon icon={faXmark as IconProp} className=" text-16 me-0" />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {design && (
                    <div className={`row mb-5`}>
                      <div className="col-12 col-md-2 text fw-bold mb-3">
                        <div className=" d-flex justify-content-between "></div>
                      </div>
                      <div className={`col-12 col-md-10 mb-5 d-flex flex-column align-items-center justify-content-center  `}>
                        {Array.from({ length: 4 }, (_, index) => {
                          const key = `image${index + 2}Attachment` as keyof DesignDetails;
                          const attachment = design[key];
                          return attachment ? (
                            <div key={index} className="mt-2 d-flex" style={{ width: '100%' }}>
                              <div className={`${styles.previewImg}`}>
                                <img src={attachment.s3Path} key={index} className={`${styles.previewImg}`} alt="uploaded" style={{ height: '100%' }} />
                              </div>
                              <div className="d-flex flex-row w-100 align-items-center justify-content-center ">
                                <span className="text-xl">{attachment.originalFileName}</span>
                              </div>
                              <div className=" d-flex align-items-center justify-content-end ">
                                <div
                                  className={`${styles.removeButton}`}
                                  // style={{ borderRadius: '8px', height: '50px', width: '50px' }}
                                  onClick={() => removeImage(index + 2)}
                                >
                                  <FontAwesomeIcon icon={faXmark as IconProp} className=" text-16 me-0" />
                                </div>
                              </div>
                            </div>
                          ) : null;
                        })}
                      </div>
                    </div>
                  )}

                  <div className="row mb-5">
                    <div className="col-12 col-md-2 text fw-bold mb-3 ps-md-1 ps-2">
                      <div className=" d-flex justify-content-between " style={{ position: 'relative', zIndex: 10 }}>
                        <div className="col-11">Archive file</div>
                        <div className=" ml-auto">
                          <FontAwesomeIcon
                            icon={faCircleQuestion as IconProp}
                            className=" text color-blue me-0 "
                            onMouseEnter={() => setPopUpArchive(true)}
                            onMouseLeave={() => setPopUpArchive(false)}
                          />
                        </div>
                        <div className={`${popUpArchive ? styles.message : styles.noMessage}`}>
                          <div className={`  ${styles.freccetta} `}></div>
                          <div className={`${styles.infoActions} p-4 text`}>
                            <i>
                              use the archive to upload client required files and/or extra content <br /> allowed format: .zip; max file size: 100 MB
                            </i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-10 mb-5">
                      <label htmlFor="archive" className={`${styles.dropcontainerarchive} d-flex position-relative flex-column justify-content-center px-5`}>
                        <label className="drop-title  fw-normal">
                          <input type="file" id="archive" accept=".zip" className={`${styles.inputfile}`} required={false} multiple={true} onInput={handleArchiveSelect} />
                          <span className="color-primary fw-normal" style={{ color: '#7997c5', cursor: 'pointer' }}>
                            Choose a file&nbsp;
                          </span>
                          <span>from your computer (allowed format: .zip max file size: 100 MB).</span>
                        </label>
                      </label>
                      {archiveFile && (
                        <div className=" d-flex mt-5 justify-content-between align-items-center">
                          <div className="d-flex w-100 align-items-center">
                            <div className={`bg-blue ${styles.filezip} `}>
                              <FontAwesomeIcon icon={faFileZipper as IconProp} className=" text me-0 color-light" style={{ fontSize: '2rem' }} />
                            </div>
                          </div>
                          <div className=" text-center">{archiveFile.name} </div>
                          <div className="d-flex w-100 align-items-center justify-content-end ">
                            <div
                              className={`${styles.removeButton}`}
                              // style={{ borderRadius: '8px', height: '50px', width: '50px' }}
                              onClick={() => setArchiveFile(undefined)}
                            >
                              <FontAwesomeIcon icon={faXmark as IconProp} className=" text-16 me-0" />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-12 col-md-2 text fw-bold mb-3 ps-md-1 ps-2">
                      <div className=" d-flex justify-content-between " style={{ position: 'relative', zIndex: 10 }}>
                        <div className="col-11">Video file</div>
                        <div className=" ml-auto">
                          <FontAwesomeIcon
                            icon={faCircleQuestion as IconProp}
                            className=" text color-blue me-0 "
                            onMouseEnter={() => setPopUpVideo(true)}
                            onMouseLeave={() => setPopUpVideo(false)}
                          />
                        </div>
                        <div className={`${popUpVideo ? styles.message : styles.noMessage}`}>
                          <div className={`  ${styles.freccetta} `}></div>
                          <div className={`${styles.infoActions} p-4 text`}>
                            <i>
                              use the archive to upload client required files and/or extra content <br /> allowed format: .zip; max file size: 50 MB
                            </i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-10 mb-5">
                      <label className={`${styles.dropcontainerarchive} d-flex position-relative flex-column justify-content-center px-5`}>
                        <label className="drop-title  fw-normal">
                          <input type="file" id="video" accept=".zip" className={`${styles.inputfile}`} required={false} multiple={false} onChange={handleVideoSelect} />
                          <span className="color-primary fw-normal" style={{ color: '#7997c5', cursor: 'pointer' }}>
                            Choose a file&nbsp;
                          </span>
                          <span>from your computer (allowed format: .zip max file size: 50 MB).</span>
                        </label>
                      </label>
                      {videoFile && (
                        <div className=" d-flex mt-5 justify-content-between align-items-center">
                          <div className="d-flex w-100 align-items-center">
                            <div className={`bg-blue ${styles.filezip} `}>
                              <FontAwesomeIcon icon={faFileVideo as IconProp} className=" text me-0 color-light" style={{ fontSize: '2rem' }} />
                            </div>
                          </div>
                          <div className=" text-center">{videoFile.name} </div>
                          <div className="d-flex w-100 align-items-center justify-content-end ">
                            <div className={`${styles.removeButton}`} onClick={() => setVideoFile(undefined)}>
                              <FontAwesomeIcon icon={faXmark as IconProp} className=" text-16 me-0" />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
              <Controller name="keywords" control={methods.control} render={({ field: { value, onChange } }) => <KeywordsEditor keywords={value || []} onChange={onChange} />} />
              <div className="row mb-5">
                <div className="col-12 col-md-2 text fw-bold mb-3 ps-md-1 ps-2">
                  <div className=" d-flex justify-content-between " style={{ zIndex: '10', position: 'relative' }}>
                    <div className="col-11">
                      Keyword <span className="color-dark_red me-1"> * </span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-10 ">
                  <input
                    type="text"
                    value={tagString}
                    style={{ height: '30px' }}
                    {...methods.register('tempTags', {
                      onChange: (e) => tagstring(e.target.value),
                    })}
                  />
                  {tagsError && (
                    <span className=" d-flex text flex-row justify-content-center align-items-center color-dark_red">
                      <FontAwesomeIcon icon={faCircleExclamation as IconProp} className=" text me-0" /> &nbsp; Please provide &nbsp; <b> keywords. </b>
                    </span>
                  )}
                  {suggestionArray.length > 0 && tagStringCheck() && (
                    <div className={`${styles.suggestionWrapper}`}>
                      {suggestionArray.map((item: DSLTag, index: number) => (
                        <div className={`text ${styles.suggestionRow}`} key={index} onClick={() => addTag(item.name)}>
                          {item.name}
                        </div>
                      ))}
                    </div>
                  )}
                  {/* <span className="  color-dark_grey_40">please separate each tag with spaces</span> */}

                  <div className="mt-3">
                    {/* {console.log(tagsArray)} */}
                    {tagsArray.map(
                      (item: string, index: number) =>
                        item !== '' && (
                          <button disabled className="btn-tag" key={index}>
                            <span>{item}</span>
                          </button>
                        )
                    )}
                  </div>
                </div>
              </div>
              <FormField name="agreement" label="Agreement" required error={methods.formState.errors.agreement}>
                <input
                  type="checkbox"
                  style={{ height: '30px', width: '30px' }}
                  {...methods.register('agreement', { required: 'You must agree before submitting' })}
                  tabIndex={0}
                />
                <label>
                  I'm over 18 and agree to the
                  <a target="_blank" rel="noreferrer" href={contest?.termsAttachmentURL && contest.termsAttachmentURL}>
                    &nbsp; Contest agreement
                  </a>
                </label>
              </FormField>

              <div className="row mb-5">
                {progress > 0 && (
                  <div className="row">
                    <div className="col-12 col-md-2 text fw-bold mb-3 ps-md-1 ps-2">
                      <div className="  d-flex justify-content-between " style={{ position: 'relative', zIndex: 10 }}>
                        <div className="col-11">Upload in progress:</div>
                      </div>
                    </div>
                    <div className="col-12 col-md-10 mb-5">
                      <div className={`${styles.progressBarWrapper}`}>
                        <div
                          className={`${styles.progressBar}`}
                          role="progressbar"
                          style={{ width: `${progress}%` }}
                          aria-valuenow={progress}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        ></div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </FormProvider>

        {progress < 5 && (
          <div className="row">
            <div className="col-12 col-md-3"></div>
            <div className="col-12 col-md-3 mb-4 px-5 align-items-center ">
              <div className="d-flex flex-row justify-content-center ">
                <div className={`btn-dark-blue rounded full`} onClick={() => showSaveDraftPopUp()}>
                  Save draft
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3 mb-4 px-5 align-items-center">
              <div className="d-flex flex-row justify-content-center ">
                <button
                  type="button"
                  className="btn-blue rounded full"
                  onClick={publish}
                >
                  Publish
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <PopUpSaveDraft
        popupVisible={saveDraftPopupVisible}
        onClose={() => {
          setSaveDraftPopupVisible(false);
          setProgress(0);
        }}
        onAccept={() => {
          console.log('accept');
          setSaveDraftPopupVisible(false);
          draft.current = true;
          setProgress(1);
          // trigger();
          methods.handleSubmit(onSubmit)();
        }}
      />
    </>
  );
};

export default UploadComponent;
